import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductDetailsAccordionComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#updateDetails);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#updateDetails);
  }

  #updateDetails = (event) => {
    const { html } = event.detail.data;
    if (!html) return;
    const newElement = html.querySelector(
      `product-details-accordion-component[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newElement) return;
    morph(this, newElement, { childrenOnly: true });
  };
}

if (!customElements.get('product-details-accordion-component')) {
  customElements.define('product-details-accordion-component', ProductDetailsAccordionComponent);
}
